<template>
  <v-container grid-list-xl>

    <v-layout align-center justify-center row fill-height>
      <file-upload @uploaded="uploadedFile=$event" />
      {{ JSON.stringify(uploadedFile)}}
      <broadcast-form/>

      <v-flex sm-4 md-3 lg-3 xs-3>
        <fireform formId="Custom Field">
          <template slot="title" slot-scope="titleProps">
            <p> {{titleProps.title}}</p>
          </template>
          <template slot="actions" slot-scope="{ disabled, submitHandler }">
            <p> actions slot</p>
            <v-btn :disabled="disabled" @click="submitHandler" color="primary">ok</v-btn>
          </template>
        </fireform>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import FileUpload from "./util/FileUpload";
import BroadcastForm from "./forms/BroadcastForm";
import Fireform from "./Fireform";

export default {
  data() {
    return {
      uploadedFile: null
    };
  },
  components: {
    FileUpload,
    BroadcastForm,
    Fireform
  },
  created() {
    this.$store.dispatch("test");
  }
};
</script>

